
import { defineComponent, ref, reactive, toRefs, onMounted, nextTick, computed, watch } from 'vue'
import { ClockCircleOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import Descriptions from '@/components/descriptions.vue'
import api from '@/api/allApi'
import Nodata from '@/components/page/nodata.vue'
import globalsets from '@/utils/globalsets'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { ClockCircleOutlined, Descriptions, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      list: [],
      opencontent1: false,
      opencontent2: false,
      open1: false,
      open2: false,
      info: {},
      spinning: true
    })
    pageData.list = [
      {
        title: '公司名称',
        key: 'CompanyName',
        opencontent: false,
        open: false,
        span: 2
      },
      {
        title: '英文名称',
        key: 'EngName',
        opencontent: false,
        open: false
      },
      {
        title: '经营范围',
        key: 'BusinessMajor',
        opencontent: false,
        open: false,
        collapse: true
      },
      {
        title: '公司介绍',
        key: 'Profile',
        opencontent: false,
        open: false,
        collapse: true
      },
      {
        title: '公司成立时间',
        key: 'EstablishmentDate',
        opencontent: false,
        open: false,
        span: 2
      },
      {
        title: '所属地区',
        key: 'ProvinceCity',
        opencontent: false,
        open: false,
        span: 2
      },
      // {
      //   title: '公司注册地',
      //   key: 'RegAddr',
      //   opencontent: false,
      //   open: false,
      //   span: 2
      // },
      {
        title: '公司注册资本(元)',
        key: 'RegCapital',
        opencontent: false,
        open: false,
        span: 2
      },
      {
        title: '所属行业',
        key: 'Industry',
        opencontent: false,
        open: false,
        span: 2
      },
      {
        title: '法人代表',
        key: 'LegalRepr',
        opencontent: false,
        open: false,
        span: 2
      },
      {
        title: '总经理',
        key: 'GeneralManager',
        opencontent: false,
        open: false,
        span: 2
      },
      {
        title: '董事会秘书',
        key: 'SecretaryBD',
        opencontent: false,
        open: false,
        span: 2
      },
      {
        title: '证券事务代表',
        key: 'SecuAffairsRepr',
        opencontent: false,
        open: false,
        span: 2
      },
      {
        title: '实际控制人',
        key: 'ControllerName',
        opencontent: false,
        open: false,
        span: 2
      },
      {
        title: '联系电话',
        key: 'ContactTel',
        opencontent: false,
        open: false,
        span: 2
      },
      {
        title: '传真',
        key: 'ContactFax',
        opencontent: false,
        open: false,
        span: 2
      },
      {
        title: '网址',
        key: 'Website',
        opencontent: false,
        open: false,
        span: 2
      },
      {
        title: 'E-Mali',
        key: 'Email',
        opencontent: false,
        open: false,
        span: 2
      },
      {
        title: '联系地址',
        key: 'ContactAddr',
        opencontent: false,
        open: false,
        span: 2
      },
      {
        title: '注册地址',
        key: 'RegAddr',
        opencontent: false,
        open: false,
        span: 2
      },
      {
        title: '办公地址',
        key: 'OfficeAddr',
        opencontent: false,
        open: false,
        span: 2
      },
      {
        title: '会计师事务所',
        key: 'AccountingFirm',
        opencontent: false,
        open: false,
        span: 2
      },
      {
        title: '法律顾问',
        key: 'LegalConsultant',
        opencontent: false,
        open: false,
        span: 2
      },
      {
        title: '主要业务',
        key: 'PrimeOperating',
        opencontent: false,
        open: false,
        span: 2
      }
    ]
    watch(
      () => props.pageSourceData,
      () => {
        const _data = props.pageSourceData || {}
        _data.ProvinceCity = _data.Province + _data.City
        _data.RegCapital = _data.RegCapital = globalsets.getNumber(_data.RegCapital)
        pageData.info = _data
        nextTick(() => {
          pageData.spinning = false
        })
      },
      { deep: true }
    )
    return {
      ...toRefs(pageData)
    }
  }
})
